export const styles = {
  message: {
    marginTop: '0.3rem',
  },
};
